import { ModalErrorPaymentComponent } from './../modal-error-payment/modal-error-payment.component';
import { Component, OnInit, ViewChild} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {DateAdapter} from '@angular/material/core';
import {TranslateService} from 'ng2-translate/ng2-translate';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';
import {ComplementPaymentsDetailComponent} from '../complement-payments-detail/complement-payments-detail.component';
import * as decode from 'jwt-decode';
import { saveAs } from 'file-saver/FileSaver';
import {DatePipe} from '@angular/common';
import {COMMA, ENTER, SPACE} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import * as XLSX from 'xlsx';

///http://127.0.0.1:4200/complementos-pagos/historial
//Reporte Estatus de carga de complemento

@Component({
  selector: 'app-complement-history',
  templateUrl: './complement-history.component.html',
  styleUrls: ['./complement-history.component.scss']
})
export class ComplementHistoryComponent implements OnInit {
  @ViewChild('fileInvView', { static: false }) fileInvView;
  userId: any;
  userToken: any;
  temp = [];
  load = true;
  data: any = {};
  filterd: any = {};
  typeFileUpload: any;
  step = 0;
  totalrows = 5150;
  loadBtn = false;
  listSocieties = [];
  listPlanta = [];
  listPlantaSel = [];
  tempSend: any = {};
  tmpProvider: any;
  listpayments = [];

  arrOc = [];
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];

  providersList=[];
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  providerActive = 'hide';
  perfilId;
  isExternal;
  checkedAll = false;


  constructor( private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService, private provService: ProvidersService, public translate: TranslateService, private adapter: DateAdapter<any>) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;

    this.perfilId = tokenPayload.IdPerfil;
    this.isExternal = tokenPayload.EsUsuarioExterno;

    this.providerActive = (this.perfilId == '3' && this.isExternal )? 'hide': 'show';

    this.getSocieties();
    this.getPlantas();

    gralService.changeTextHead('HISTORYCOMPLEMENTS');

    translate.onLangChange.subscribe(lang => {
      if(lang.lang == 'en'){
        this.adapter.setLocale('en-GB');
      }

      if(lang.lang == 'es'){
        this.adapter.setLocale('es-MX');
      }
    });
  }

  ngOnInit() {
    this.loadProviders();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

    this.data.FechaFin = new Date();

  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders(){
    this.provService.getProvidersNum(this.userToken).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
        if(this.listSocieties.length == 1){
          this.data.society = this.listSocieties[0].NoSociedad;
          this.data.Sociedad = this.listSocieties[0].NoSociedad;
          this.selectSociety(0);
        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(pos){

    if(this.perfilId==3){
      let List = this.listSocieties;
      this.arrOc = [];
      this.arrOc.push(List[pos].NumProveedor);
    }


    this.listPlantaSel = this.listPlanta.filter(x => x.IdSociedad == this.listSocieties[pos].IdSociedad || x.IdSociedad  == 0 );
    this.data.Plant = null;
    // const society = this.listSocieties.find(x => x.NoSociedad == this.data.Sociedad);
    // if(society){
    //   if(society.NumProveedor){

    //     //this.data.Proveedor = society.NumProveedor;
    //     this.arrOc.push(society.NumProveedor);
    //   }
    // }
  }

  getPlantas(){
    this.provService.getPlantas(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listPlanta = data['Entidades'];

      }else{
        this.listPlanta = null;
      }
    }, (err) => {

      this.loadBtn = false;
      this.listPlanta = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectPlanta(index){

    const planta = this.listPlanta[index];
    if(planta.NoPlanta){
      this.data.Plant = planta.BusArea;
    }

  }

  disabledProv(){
    let resp = false;
    if(this.data.Sociedad){
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.Sociedad);
      if(society.NumProveedor){
        resp = true;
      }
    }
    return resp;
  }

  search(){
    this.data.Proveedor = this.arrOc.join();
    if( !this.data.Sociedad || !this.data.FechaInicio || !this.data.FechaFin){
      let body = "Favor de ingresar todos los campos";
      if(this.translate.currentLang == "es"){
        body = "Favor de ingresar todos los campos";
      }else if(this.translate.currentLang == "en"){
        body = "Please enter all fields";
      }
      this.toastr.error(body, 'Error');
      return;
    }

    this.step = 0;
    this.listpayments = null;
    this.loadBtn = true;
    const datePipe = new DatePipe('en-US');
    const params = {
      FechaFin: datePipe.transform(this.data.FechaFin, 'yyyy-MM-dd'),
      FechaInicio: datePipe.transform(this.data.FechaInicio, 'yyyy-MM-dd'),
      Proveedor: this.data.Proveedor,
      Sociedad: this.data.Sociedad,
      BUS_AREA: this.data.Plant
    };

    this.tempSend = params;
    this.provService.searchHistoryComplePayments(params, this.userToken).then((resp) => {
      this.loadBtn = false;
      if(resp['consultaExitosa']){
        this.listpayments = resp['listaPagosComplemento'];
        this.temp = resp['listaPagosComplemento'];
        this.step = 1;
        setTimeout(()=>{
          this.filterData();
        } , 1000)
      }else{
        let body = "Este complemento no tiene pagos";
        let title = "Complemento de pago";
        if(this.translate.currentLang == "es"){
          body = "Este complemento no tiene pagos";
          title = "Complemento de pago";
        }else if(this.translate.currentLang == "en"){
          body = "This complement has no payments";
          title = "Pay complement";
        }
        this.toastr.info(body, title);
        return;
      }
    }, (err) => {

      this.step = 0;
      this.listpayments = null;
      this.loadBtn = false;
      this.toastr.error(JSON.stringify(err), 'Error');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  invoices(id, idx, PagoCompensado){
    this.provService.invoicesHistoryComplePayments({IdPagoCompensado: PagoCompensado}, this.userToken).then((resp) => {
      this.loadBtn = false;
      if(resp['consultaExitosa']){
        this.dialog.open(ComplementPaymentsDetailComponent, {
          minWidth: '80%',
          position: {
            top: '6%'
          },
          data: { type: 'hist-invoices', id: id, invoices: resp['listaFacturasDePagosConComplemento'] }
        });
      }else{
        let body = 'Este complemento no tiene facturas';
        let title = "Complemento de pago";
        if(this.translate.currentLang == "es"){
          body = 'Este complemento no tiene facturas';
          title = "Complemento de pago";
        }else if(this.translate.currentLang == "en"){
          body = "This complement has no invoices";
          title = "Pay complement";
        }
        this.toastr.info(body, title);
        return;
      }
    }, (err) => {
      console.log(err);
      this.step = 0;
      this.listpayments = null;
      this.loadBtn = false;
      this.toastr.error(JSON.stringify(err), 'Error');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  download(id, idx){
    console.log(id, idx);
    this.provService.downloadHistoryComplement(id, this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      console.log(data);
      if(data['respuestaExitosa']){
        const sampleBytes = this.base64ToArrayBuffer(data['File'].FileContent);
        const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
        saveAs(blob, data['File'].FileName);
      }else{
        let body = 'No se puede descargar el archivo';
        let title = "Descargar historial";
        if(this.translate.currentLang == "es"){
          body = 'No se puede descargar el archivo';
          title = "Descargar historial";
        }else if(this.translate.currentLang == "en"){
          body = "Unable to download file";
          title = "Download history";
        }
        this.toastr.info(body, title);
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      let body = 'No se puede descargar el archivo';
        let title = "Descargar historial";
        if(this.translate.currentLang == "es"){
          body = 'No se puede descargar el archivo';
          title = "Descargar historial";
        }else if(this.translate.currentLang == "en"){
          body = "Unable to download file";
          title = "Download history";
        }
        this.toastr.info(body, title);
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  base64ToArrayBuffer(base64) {
    const binaryString =  window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++)        {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.arrOc.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(oc): void {
    const index = this.arrOc.indexOf(oc);
    if (index >= 0) {
      this.arrOc.splice(index, 1);
    }
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrOc.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrOc.push(value.trim());
          }
        }
      })
  }



  exportExcel(){

    const datePipe = new DatePipe('en-US');
    const params = {FechaFin: datePipe.transform(this.data.FechaFin, 'yyyy-MM-dd'), FechaInicio: datePipe.transform(this.data.FechaInicio, 'yyyy-MM-dd'), Proveedor: this.data.Proveedor, Sociedad: this.data.Sociedad};
    this.tempSend = params;
    this.provService.exportToExcel(params, this.userToken).then((resp:any) => {
      let data = resp['File'];


      const sampleBytes = this.base64ToArrayBuffer(data.FileContent);
      const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
      saveAs(blob, data['FileName']);
    });
  }

  addProveedorSearch(option){
    console.log('option', option);
    let value = this.myControl.value;
    if ((value || '').trim()) {
      let proveedor = value.split(' - ');
      this.arrOc.push(proveedor[0]);
    }

    this.myControl.setValue('');
  }

  openError(pos){

    this.dialog.open(ModalErrorPaymentComponent, {
      minWidth: '80%',
      position: {
        top: '6%'
      },
      //data: { msjError: this.listpayments[pos].MensajeValidacion }
      data: { msjError: pos }
    });
  }


  selectAll(){
    for(let g = 0; g < this.listpayments.length; g++){
      this.listpayments[g].select = this.checkedAll;
      //this.sumTot();
    }
  }

  DescargaMasiva(){
    this.filterUUID((res)=>{

      if(res.length >0){
        const _tempUUID = {uuid: res };
        this.provService.descargaMasiva(_tempUUID, 'llll').then((res:any)=>{
        this.loadBtn = false;
        if(res.resultado){
          let mimeType;
          if(res.Entidad.esPdf || res.Entidad.esXml ){
            const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
            const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });


            if(!res.Entidad.esZip){
              mimeType = (res.Entidad.esPdf)?'.pdf': '.xml';
            }else{
              mimeType =  '.zip';
            }

            let fileName= Date.now();
            let tempName = fileName+mimeType;

            saveAs(blob, tempName);
          }else if(res.Entidad.esZip){
            const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
            const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
            mimeType =  '.zip';
            let fileName= Date.now();
            let tempName = fileName+'.zip';

            saveAs(blob, tempName);
          }
        }


        });
      }else{
        let body = 'Debe seleccionar al menos una factura';
        let title = "Descargar masiva";
        if(this.translate.currentLang == "es"){
          body = 'Debe seleccionar al menos una factura';
          title = "Descargar masiva";
        }else if(this.translate.currentLang == "en"){
          body = "You must select at least one invoice";
          title = "Bulk download";
        }
        this.toastr.info(body, title);
      }
    })

  }

  filterUUID(callbak){
    let finalList = [];

    for(let i = 0; i < this.listpayments.length; i++ ){
      if(this.listpayments[i].select){
        let _UUID = this.listpayments[i].UUIDComplemento;
        finalList.push(_UUID);
      }
    }
    return callbak(finalList);
  }


  filterStatus(val) {
    // filter our data //
    const temp = this.temp.filter(function(d) {
      let ret = d.Estatus.indexOf(val) !== -1 || !val;
      return ret;
    });

    // update the rows
    this.listpayments = temp;
  }

  /************** exportar a excel **************/
  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    //const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listpayments);
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listExport);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName('estatus_carga'));
  }

  listExport=[];
  filterData(){
    this.listExport = [];
    let obj = this.temp;
    for(let i = 0; i < obj.length; i++ ){
      let estatus = null;

      if(obj[i].Estatus == 1 ){
        estatus = 'Válido';
      }else if(obj[i].Estatus == 2){
        estatus = 'Pendiente';
      }else{
        estatus = 'Error';
      }

      let objInclude = {
                          "Sociedad":       obj[i].NumeroSociedad,
                          "Proveedor":      obj[i].NumeroProveedor,
                          "Razón social":   obj[i].RazonSocial,
                          "No. documento compensación":  obj[i].DocumentoCompensacion,
                          "Importe":        obj[i].Importe,
                          "Fecha pago":     obj[i].FechaPago,
                          "Moneda":         obj[i].Moneda,
                          "Bus Area":       obj[i].BUS_AREA,
                          "Fecha de carga": obj[i].FechaCarga,
                          "UUID":           obj[i].UUIDComplemento ,
                          "Estatus":        estatus
                        };
      this.listExport.push(objInclude);
    }

  }
  /************** exportar a excel **************/

  // autorizar pago //
  autorizaPago(id){
    let params ={ IdPagoCompensado: id }
    this.provService.autorizaPagos( params, '123').then((res:any)=>{
      if(res.respuestaExitosa){
        let body = 'Pago autorizado correctamente';
        let title = "Descargar masiva";
        if(this.translate.currentLang == "es"){
          body = 'Pago autorizado correctamente';
          title = "Descargar masiva";
        }else if(this.translate.currentLang == "en"){
          body = "Payment authorized correctly";
          title = "Bulk download";
        }
        this.toastr.success(body, '');
      }else{
        this.toastr.error(res.mensajeProceso, 'Error');
      }
    });
  }

  deleteComplement(id){
    let params ={ IdPagoCompensado: id }
    this.provService.borrarComplemento(params, '123').then((res:any)=>{
      if(res.EsValido){
        let body = 'Pago eliminado correctamente';
        let title = "Descargar masiva";
        if(this.translate.currentLang == "es"){
          body = 'Pago eliminado correctamente';
          title = "Descargar masiva";
        }else if(this.translate.currentLang == "en"){
          body = "Payment removed correctly";
          title = "Bulk download";
        }
        this.toastr.success(body, '');
      }else{
        this.toastr.error(res.MensajeUsuario, 'Error');
      }
    });
  }
}
